<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.products'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.supplierProductNo"
            :placeholder="$t('product.supplierProductNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-checkbox
              v-model="checkAllDF"
              value="1"
              style="margin-right: 10px"
              @change="checkAll"
              >{{ $t("action.checkAll") }}</el-checkbox
            >

            <el-button type="primary" size="mini" @click="batchShow">{{
              $t("action.show")
            }}</el-button>
            <el-button type="info" size="mini" @click="batchCancelShow">{{
              $t("action.cancelShow")
            }}</el-button>

            <el-dropdown class="mgl10 mgr10" @command="selectSerial">
              <el-button type="default" size="mini">
                {{ $t("menu.serials") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="serial of serials"
                  :key="serial.id"
                  :command="serial"
                >
                  <div>{{ serial.name }}</div>
                </el-dropdown-item>
                <el-dropdown-item :command="-1" divided>
                  <div>取消系列</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              type="default"
              size="mini"
              @click="print('printQrCodeDiv')"
            >
              {{ $t("action.print") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <div :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <div class="product-checkbox-div" style="z-index: 2">
                      <input
                        v-model="checkedProducts"
                        type="checkbox"
                        :value="row"
                        class="float-right"
                        @change="checkedProduct"
                      />
                    </div>
                    <div
                      v-if="row.productLabels.length != 0"
                      class="product-label-div"
                      style="z-index: 2"
                    >
                      <span
                        v-for="productLabel in row.productLabels.slice(0, 6)"
                        :key="productLabel.id"
                        class="float-left product-label"
                      >
                        <raw-html-limit-number
                          :content="productLabel.name"
                          :number="5"
                        />
                      </span>

                      <span
                        v-if="row.productLabels.length > 6"
                        class="float-left product-label"
                      >
                        ...
                      </span>
                    </div>
                    <thumbnail
                      :images="row.images"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div class="pd5">
                    <el-row class="mgb5">
                      <el-col :span="16" class="overflow">
                        <span v-if="row.verifyAt != null" class="green font10">
                          ({{ $t("product.verify") }})
                        </span>
                        <span class="blue" @click="showRow(row, rowIndex)">
                          {{ row.productNo }}
                        </span>
                      </el-col>

                      <el-col :span="8" class="right font10">
                        <span v-if="row.isScore == true" class="orange font10">
                          {{ $t("product.score") }}
                        </span>
                        <span v-if="row.showShop == true" class="green">
                          {{ $t("action.show") }}</span
                        >
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 21px">
                          {{ row.categoryName }}
                        </div>
                      </el-col>
                      <el-col
                        v-if="Permit.canActions('globalSalePrice')"
                        :span="12"
                        class="overflow right red"
                        ><currency
                          :code="row.salesCurrency"
                          v-if="row.salesPrice != null"
                        ></currency
                        >{{ row.salesPrice }}</el-col
                      >
                    </el-row>
                    <el-row>
                      <el-col :span="14">
                        <span style="height: 28px; line-height: 28px">
                          <span
                            class="blue font10 mgr8"
                            @click="editRow(row, rowIndex)"
                            >{{ $t("text.edit") }}</span
                          >
                          <span class="blue font10" @click="refreshRow(row)">{{
                            $t("action.refresh")
                          }}</span>
                        </span>
                      </el-col>
                      <el-col :span="10" class="overflow font8 right mgt5">
                        {{ row.serialName }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
      </div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :uuid="currentRowUuid" @updateInfo="showRowClose" />
    </drawer>

    <!-- 编辑 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.name')"
              :prop="'name'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.name')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('product.depositPrice')"
              :prop="'depositPrice'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('product.depositPrice')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.depositPrice" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('product.showPrice')" :prop="'showPrice'">
              <el-checkbox v-model="editObj.showPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('product.isScore')" :prop="'isScore'">
              <el-checkbox v-model="editObj.isScore" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('product.score')"
              label-width="130px"
              :prop="'score'"
              v-if="editObj.isScore == true"
              required
            >
              <el-input size="small" v-model.trim="editObj.score" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('product.shopImages')" :prop="'shopImages'">
          <dropzone v-model="editObj.shopImages" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editSubmitDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <div id="printQrCodeDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <qrcode :value="qrCodes(cp)" :options="{ width: 100 }" :tag="'img'" />
        </div>
        <div style="padding-left: 10px">
          <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
          <div>{{ $t("product.category") }}：{{ cp.categoryName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import QRCode from "qrcode";
import PagerConfig from "@/config/pager.js";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Dropzone from "@/components/Dropzone";
import Currency from "@/components/Currency";
import Settings from "@/settings";

import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Label from "@/api/label.js";
import Brand from "@/api/brand";
import Serial from "@/api/serial";

import Show from "./show.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Qrcode,
    QRCode,
    Show,
    Dropzone,
    Currency,
  },
  data() {
    return {
      Util: Util,
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      narrows: [
        [
          {
            label: this.$t("product.verifyInfo"),
            items: [
              {
                label: this.$t("verifyInfos.yes"),
                key: "yes",
                condition: { verify: "yes" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { verify: "no" },
              },
            ],
          },
          {
            label: this.$t("action.show"),
            items: [
              {
                label: this.$t("boolean.true"),
                key: "showShopYes",
                condition: { showShop: "yes" },
              },
              {
                label: this.$t("boolean.false"),
                key: "showShopNo",
                condition: { showShop: "no" },
              },
            ],
          },
          {
            label: this.$t("product.isScore"),
            items: [
              {
                label: this.$t("boolean.true"),
                key: "isScoreYes",
                condition: { isScore: "yes" },
              },
              {
                label: this.$t("boolean.false"),
                key: "isScoreNo",
                condition: { isScore: "no" },
              },
            ],
          },
        ],
      ],

      searchForm: {
        productNo: null,
        supplierProductNo: null,
      },
      sorter: {
        sortBy: "products_refreshAt",
        sortIndicator: "desc",
      },
      initFilter: "showShopYes",
      Util: Util,
      checkedProducts: [],
      checkAllDF: false,
      serials: [],
      //
      currentRowUuid: null,
      currentRowIdx: null,
      showDF: false,
      //
      editDF: false,
      editObj: {
        name: null,
        shopImages: null,
        isScore: null,
        score: null,
        showPrice: null,
        depositPrice: null,
      },
      editSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    axios
      .all([
        Category.findByTenantId(),
        Label.findByTenantId(),
        Brand.findByTenantId(),
        Serial.findByTenantId(),
      ])
      .then(
        axios.spread(function (categories, labels, brands, serials) {
          if (categories.status === 200) {
            if (categories.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("product.category"),
                  items: categories.data.map((category) => {
                    return {
                      label: category.name,
                      key: category.id,
                      condition: { categoryId: category.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (labels.status === 200) {
            self.labels = labels.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.narrows.push([
              {
                label: self.$t("product.label"),
                items: labels.data.map((label) => {
                  return {
                    label: label.name,
                    key: label.name,
                    condition: { label: label.name },
                  };
                }),
              },
              {
                label: self.$t("product.brand"),
                items: brands.data.map((brand) => {
                  return {
                    label: brand.name,
                    key: brand.name,
                    condition: { brand: brand.name },
                  };
                }),
              },
            ]);
          } else {
            self.sysError();
          }
          if (serials.status === 200) {
            self.serials = serials.data;

            self.narrows.push([
              {
                label: self.$t("menu.serials"),
                items: serials.data.map((serial) => {
                  return {
                    label: serial.name,
                    key: serial.id,
                    condition: { serialId: serial.id },
                  };
                }),
              },
            ]);
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    print(type) {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneValidData"));
        return;
      }
      self.printFunction(type);
    },

    qrCodes(cp) {
      let text =
        "/products/show/" + cp.uuid + "/" + this.Permit.currentUser().phone;
      return Settings.mobileEndpoint + text;
    },

    selectSerial(serial) {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }
      let obj = {
        ids: self.checkedProducts.map((c) => c.id),
        serialId: serial.id != -1 ? serial.id : null,
        serialName: serial.id != -1 ? serial.name : null,
      };
      Product.batchUpdateSerial(obj).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.loadData();
          self.checkedProducts = [];
        } else {
          self.sysError();
        }
      });
    },
    // 批量
    batchShow() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }
      const currencies = self.checkedProducts.map((c) => c.salesCurrency);
      const currenciesSet = [...new Set(currencies)];
      if (
        currenciesSet.length != 1 ||
        (currenciesSet.length == 1 && currenciesSet[0] != "CNY")
      ) {
        self.$message({
          message: "上架的产品币种必须是 人民币",
          type: "warning",
        });
        return;
      }
      Product.batchShow(self.checkedProducts.map((c) => c.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.showSuccess"),
            type: "success",
          });
          self.loadData();
          self.checkedProducts = [];
        } else {
          self.sysError();
        }
      });
    },

    batchCancelShow() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidData"),
          type: "warning",
        });
        return;
      }
      Product.batchCancelShow(self.checkedProducts.map((c) => c.id)).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.cancelShowSuccess"),
              type: "success",
            });
            self.loadData();
            self.checkedProducts = [];
          } else {
            self.sysError();
          }
        }
      );
    },
    //
    editRow(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.shopImages = row.shopImages;
      self.editObj.isScore = row.isScore;
      self.editObj.score = row.score;
      self.editObj.showPrice = row.showPrice;
      if (row.depositPrice == null || (row.depositPrice ?? "") == "") {
        self.editObj.depositPrice = row.salesPrice;
      } else {
        self.editObj.depositPrice = row.depositPrice;
      }
      self.editSubmitDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (self.editObj.isScore == true) {
            if (!Util.regexNumber(self.editObj.score)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("product.score")]),
                type: "warning",
              });
              return;
            }
          }
          self.editSubmitDoing = true;
          Product.updateYshopInfo(self.row.id, self.editObj).then(function (
            res
          ) {
            self.editSubmitDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 刷新
    refreshRow(row) {
      const self = this;
      Product.refresh(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.refreshSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    showRow(row, rowIndex) {
      this.currentRowUuid = row.uuid;
      this.currentRowIdx = rowIndex;
      this.showDF = true;
    },
    showRowClose() {
      this.showDF = false;
    },
    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },

    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records;
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },

    dataProvider(params) {
      return Product.search(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 0 0 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 80px; */
  /* overflow: hidden; */
}
</style>